import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from '../../../../environments/environment';
import { DateConv } from '../../../helpers/date-conv';
import { FoodScoreI } from '../../../interfaces/foods/food-score.interface';
import { FoodI } from '../../../interfaces/foods/foods.interface';
import { UserI } from '../../../interfaces/users/user.interface';
import { FoodsService } from '../../../services/foods.service';
import { MessageService } from '../../../services/message.service';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-user-foods-list',
  templateUrl: './user-foods-list.component.html',
  styleUrls: ['./user-foods-list.component.scss']
})
export class UserFoodsListComponent implements OnInit {

 // region Atributos
  @Input() userFoods: FoodI[];
  @Input() user: UserI;
  @Output() submit = new EventEmitter();
  @Output() closeModal = new EventEmitter();

  @Input() modalMode: boolean;

  searchKey: string;
  listFoods: MatTableDataSource<any>;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  listOfColumns: string[] = ['comida', 'puntuacion'];
  public spinner = false;

  public foodFormArray: FormArray;
  // endregion

  // region Constructor
  constructor(
    public messageService: MessageService,
    public fb: FormBuilder,
    public foodServ: FoodsService,

  ) {

    this.foodFormArray = this.fb.array([]);
  }

  // endregion

  // region Métodos
  ngOnInit() {
    for (let i = 0; i < this.userFoods.length; i++) {
      this.userFoods[i].imgURL = (this.userFoods[i].img) ? `${environment.filestorage}/food_images/${this.userFoods[i].img}` : 'assets/img/food-default.png';
      this.userFoods[i].date_reg = DateConv.transFormDate(this.userFoods[i].created_at, 'slash');
      this.userFoods[i].time_reg = DateConv.transFormDate(this.userFoods[i].created_at, 'time');
    }
    this.listFoods = new MatTableDataSource(this.userFoods);

    this.listFoods.sort = this.sort;
    this.listFoods.paginator = this.paginator;

    for (let i = 0; i < this.userFoods.length; i++) {
      this.foodFormArray.push(this.createFoodArray(this.userFoods[i].id, this.userFoods[i].food_score));
    }

    //console.log(this.foodFormArray.controls[0]['controls'].comment.value);

  }

  createFoodArray(food_id?, food_score?: FoodScoreI) {
    return this.fb.group({
      id: [(food_score && food_score.id) ? food_score.id: 0],
      food_id: [(food_id) ? food_id : 0],
      protein: [(food_score && food_score.protein) ? food_score.protein : 0],
      fat: [(food_score && food_score.fat) ? food_score.fat : 0],
      fruit_vegetable: [(food_score && food_score.fruit_vegetable) ? food_score.fruit_vegetable : 0],
      starch: [(food_score && food_score.starch) ? food_score.starch : 0],
      qualification: [(food_score && food_score.qualification) ? food_score.qualification : 0],
      comment: [(food_score && food_score.comment) ? food_score.comment : null, Validators.required]
    })
  }

  // Función para borrar el filtro de busqueda
  onSearchClear() {
    this.searchKey = '';
    this.applyFilter();
  }

  // Función para aplicar el filtro de busqueda
  applyFilter() {
    this.listFoods.filter = this.searchKey.trim().toLocaleLowerCase();
  }

  calcFood(control, formFood) {
    if (control.value >= 1) {
      control.setValue(1);
      //return;
    }

    if (control.value <=0) {
      control.setValue(0);
    }

    let proteinVal = Number(formFood.controls['protein'].value);
    let fatVal = Number(formFood.controls['fat'].value);
    let fruit_vegetableVal = Number(formFood.controls['fruit_vegetable'].value);
    let starchVal = Number(formFood.controls['starch'].value);

    let qualificationVal = proteinVal + fatVal + fruit_vegetableVal + starchVal;

    formFood.controls['qualification'].setValue(qualificationVal);

    console.log('calificacion', qualificationVal);

  }

  increaseValue(idcontrol, index, control) {
    //@ts-ignore
    document.getElementById(idcontrol+index).stepUp();
    let val = Number(control.value) + Number(0.5);
    control.setValue(val);
    document.getElementById(idcontrol+index).dispatchEvent(new Event('change'));
  }

  decrementValue(idcontrol, index, control) {
    //@ts-ignore
    document.getElementById(idcontrol+index).stepUp();
    let val = Number(control.value) - Number(0.5);
    control.setValue(val);
    document.getElementById(idcontrol+index).dispatchEvent(new Event('change'));
  }

  qualifyFood(formFood) {
    if (formFood.invalid) {
      this.messageService.printStatus('Debe llenar los campos marcados en rojo', 'warning');
      formFood.markAllAsTouched();
      return;
    }

    this.messageService.confirmRequest('¿Estás seguro de guardar esta información?').then((data) => {
      if (data.value) {
        if (formFood['controls']['id'].value > 0) {
          this.foodServ.updateQualify(formFood['controls']['id'].value, formFood.value).subscribe(res => {
            if (res.ok === true) {
              this.messageService.printStatus(res.message, 'success');
              this.submit.emit(true);
            }
          }, error => {
            console.log(error);
            this.messageService.printStatusArray(error.error.errors, 'error');
          });
        } else {
          this.foodServ.storeQualify(formFood.value).subscribe(res => {
            if (res.ok === true) {
              this.messageService.printStatus(res.message, 'success');
              this.submit.emit(true);
            }
          }, error => {
            console.log(error);
            this.messageService.printStatusArray(error.error.errors, 'error');
          });
        }
      }
    });
  }

  onClose() {
    this.closeModal.emit();
  }

  openLighShowImg(imgURL) {

    // Get the modal
    let modal = document.getElementById("myModal");

    // Get the image and insert it inside the modal - use its "alt" text as a caption
    //var img = document.getElementById(idelement);
    var modalImg = document.getElementById("img01");
    var captionText = document.getElementById("caption");
    modal.style.display = "block";
    //@ts-ignore
    modalImg.src = this.src;
    //@ts-ignore
    captionText.innerHTML = 'test';

    // Get the <span> element that closes the modal
    var span = document.getElementsByClassName("close")[0];

    // When the user clicks on <span> (x), close the modal
    //@ts-ignore
    span.onclick = function() {
      modal.style.display = "none";
    }
  }

  deleteFood(row: FoodI) {
    this.messageService.confirmRequest('¿Estás seguro de querer eliminar este registro?').then((data) => {
      if (data.value) {
        this.foodServ.deleteFoodPost(row.id).subscribe(res => {
          if (res.ok === true) {
            this.messageService.printStatus(res.message, 'success');
            this.submit.emit(true);
          }
        }, error => {
          console.log(error);
          this.messageService.printStatusArray(error.error.errors, 'error');
        })
      }
    })
  }

  // endregion

}
